// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonIcon } from "@insite/mobius/Button";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import IconModalCloseInactive from "@tps/XDL/Icons/IconModalCloseInactive";
import { xBaseTheme } from "@tps/XDL/types";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 430,
        medium: 543,
        large: 882,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
            `,
            modalTitle: css`
                position: relative;
                padding: 16px 16px 12px;
                border-bottom: 0;
                &:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width: calc(100% - 32px);
                    height: 1px;
                    border-top: 1px solid ${color("common.border")};
                    margin: 0 auto;
                }
            `,
            modalContent: css`
                padding: 12px 16px 16px;
                overflow-y: auto;
            `,
            modalBody: css`
                overflow: visible;
                background-color: ${color("common.white")};
                ${xScreen("lt", "md")} {
                    height: auto;
                    max-height: calc(100% - 30px);
                    margin: 15px;
                    max-width: 90%;
                }
            `,
        },
        headlineTypographyProps: {
            size: 16,
            weight: 700,
            lineHeight: "17px",
            variant: "h5",
        },
        closeButtonProps: {
            mergeCss: true,
            shape: "pill",
            buttonType: "solid",
            css: css`
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -9px;
                right: -9px;
                margin: 0;
                width: 32px;
                height: 32px;
                border-radius: 16px;
                border: 0;
                min-height: initial;
                padding: 0;
                z-index: 1;
                ${ButtonIcon} {
                    top: 0;
                }
                &:hover {
                    background: transparent;
                    svg circle {
                        fill: ${color("common.ui8")};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: IconModalCloseInactive,
            size: 32,
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
    },
} as xBaseTheme["modal"];
